<template>
    <div>
      <div class="van-overlay" style="z-index: 2001;" v-if="showBack"></div>
      <div role="dialog" class="van-dialog" aria-labelledby="提示" style="z-index: 2008;" v-if="showButton">
        <div class="van-dialog__header">提示</div>
        <div class="van-dialog__content">
          <div class="van-dialog__message van-dialog__message--has-title">请先实名认证！</div>
          </div>
          <div class="van-hairline--top van-dialog__footer">
            <button class="van-button van-button--default van-button--large van-dialog__confirm" @click="funClose">
              <div class="van-button__content">
                <span class="van-button__text">确认</span>
                </div>
                </button>
                </div>
                </div>
    </div>
</template>
<script src=""></script>
<script>
import axios from 'axios';
import { getMsg } from '../tools/get';
import { Dialog } from 'vant'

export default {
    data() {
        return {
            phoneNo: "",
            idCardNo: "",
            showBack: true,
            showButton: true
        }
    },

    created() {
        this.getUrls()
    },

    methods: {

        // 获取用户信息
        getUserInfo() {
            let noData = {
                "app_key": "WDSY_XZSPJ_YYQH",
                "version": "1.0.0",
                "data": {}
            }
            dsBridge.call("BusinessApi.getUserInfo", noData, function(res) {
                let result = JSON.parse(res);
                console.log(result)
            })
        },

        // 获取url上的参数
        getUrls() {
            let url = location.search();
            console.log(url)
            let data = new Object();
            if(url.indexOf("?") != -1) {
                let str = url.substr(1);
                let strs = str.split("&");
                for(let i = 0; i < strs.length; i++) {
                    data[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1])
                }
            }
            console.log(data)
            return data;
        },

        // 关闭网页
        funClose(){
            window.opener = null;
            window.open('', '_self');
            window.close();
            this.showButton = false;
            this.showBack = false;
        }
    }
}
</script>
<style scoped>
.pop {
    width: 100px;
    height: 50px;
    background: chartreuse;
}
</style>